'use client'

import React from 'react';
import dynamic from 'next/dynamic';
import animationData from '../lottie/anim_podo_prestudy_dialog.json';

const LazyLottie = dynamic(() => import('react-lottie-player').then((mod) => mod), { ssr: false });

export interface AnimPodoPrestudyDialogIconLottieProps {
  className?: string;
  style?: React.CSSProperties;
  loop?: boolean;
  play?: boolean;
  speed?: number;
}

const AnimPodoPrestudyDialogIconLottie: React.FC<AnimPodoPrestudyDialogIconLottieProps> = ({
  className,
  style,
  loop = true,
  play = true,
  speed = 1,
}) => {
  return (
    <LazyLottie
      animationData={animationData}
      className={className}
      style={style}
      loop={loop}
      play={play}
      speed={speed}
    />
  );
};

export default AnimPodoPrestudyDialogIconLottie;
